import React from 'react';
import './loader.scss';

const Loader = () => (
  <div className="loader-wrapper">
    <div className="loader" />
  </div>
);

export default Loader;
